<template>
  <div id="LayoutMain">
    <router-view />
    <TopBar />
  </div>
</template>

<script>
import TopBar from '@components/navigation/TopBar'

export default {
  components: {
    TopBar,
  },
}
</script>

<style lang="scss">
#LayoutMain {
  margin-top: $topbar-height-compact;
  @include md {
    margin-top: $topbar-height;
  }
}
</style>
